// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__25PwT","row":"Node_row__oAdn4","label":"Node_label__3uSfp","footer":"Node_footer__G62Tk"};